import { isSignedIn } from 'redux/actions/accountActions'
import { setAccount } from 'redux/actions/accountActions'
import { setCurrentAsset } from 'redux/actions/assetActions'
import { setCurrentRoom } from 'redux/actions/messagesActions'
import { logWithTime } from 'util/screenUtils'
import { getAsset, handleErrors } from './AssetController'
import { getCoreServiceFetchOptions } from './CoreServiceController'

/** For a Public room there is no need to check access. 
 * 
 * Since we now go to a room even if there is no accessToken -- because
 * the sign in prompt occurs in the Vortex component -- we need to check access
 * after that sign in occurs.
 * 
 * @todo Check Room access after sign in
 * 
 *  I
 * @param {*} asset         Must contain the room
 * @param {*} dispatch 
 * @param {*} onError 
 */
const checkRoom = async (asset, dispatch, onError) => {
    try {
        const { room } = asset
        const { accessType, name } = room
        logWithTime(`checkRoom ${name} public ${accessType}`)
        if (!isSignedIn()) {
            return gotoRoom(asset, accessType, dispatch)
        } else {
            console.log(`checkRoom`, asset)
            const { _id } = asset
            const response = await checkRoomAccess({ _id })
            const { status } = response
            switch (status) {
                case 200:
                    const access = await response.json()
                    console.log('checkRoom access', access)
                    const { accessType } = access
                    return gotoRoom(asset, accessType, dispatch)

                case 401:
                    console.error('checkRoom Unauthorized')
                    setAccount(null)
                    onError({ status, message: 'Unauthorized' })
                    break

                case 403:
                    //This is only returned if the room is private and this user is not the owner.
                    onError({ status, message: 'Private room' })
                    break
                default:
                    console.log('response', response)
                    if (response.statusText) {
                        onError({ status, message: response.statusText })
                    } else {
                        const error = await response.json()
                        onError({ status, message: error.message })
                    }
                    break
            }
        }
    } catch (error) {
        console.error(error)
        onError(error.message)
    }
    return null
}

/**
 * 
 * @param {*} asset 
 * @param {*} accessType 
 * @param {*} dispatch 
 * @returns 
 */
const gotoRoom = (asset, accessType, dispatch) => {
    dispatch(setCurrentAsset({ ...asset, accessType }))
    const { _id, room, category } = asset
    console.log(`gotoRoom room category ${category} `, room)
    dispatch(setCurrentRoom({ ...room, category }, 2))
    return ({ ...room, assetId: _id, category })
}

/**
 * Get the requested asset then call checkRoom to go to the room. If the Asset does not exist go to
 * the home page. If there is an error call onError.
 * 
 * The Core Service only requires title aka room name and handle aka room owner User handle to
 * get the Asset.
 * @param {*} title 
 * @param {*} handle 
 * @param {*} history 
 * @param {*} dispatch 
 * @param {*} onError 
 * @returns 
 */
export const getAndConnectRoom = async (title, handle, history, dispatch, onError) => {
    console.log(`***getAndConnectRoom ${title} ${handle} `)
    try {
        const roomAsset = await getAsset({ title, handle })
        console.log(`...getAndConnectRoom received`, roomAsset)
        if (roomAsset) {
            return checkRoom(roomAsset, dispatch, onError)
        } else {
            history.replace('/')
        }
    } catch (exc) {
        onError(exc)
    }
    return null
}

/**
 * The only element the Core Service needs is the Asset _id so don't send
 * a request with the whole Asset in i.
 * @param {*} assetParams  {_id}
 * @returns the fetch response
 */
export const checkRoomAccess = async (assetParams) => {
    console.log(`checkRoomAccess`, assetParams)
    const url = `${process.env.REACT_APP_CORE_SERVICE}vortex/checkRoomAccess`
    const options = getCoreServiceFetchOptions('POST', JSON.stringify(assetParams))
    console.log('...options', options)
    return fetch(url, getCoreServiceFetchOptions('POST', JSON.stringify(assetParams)))
}

/**
 * @param {*} roomParams 
 * @returns 
 */
export const addRoom = async (roomParams) => {

    return fetch(`${process.env.REACT_APP_CORE_SERVICE}vortex/addRoom`,
        getCoreServiceFetchOptions('POST', JSON.stringify(roomParams)))
        .then(handleErrors)
        .then((res) => res.json())
        .then((room) => {
            console.log('Added room', room)
            return room
        })
}


/**
 * 
 * @param {*} videoPath     The relative root directory for the media that will be deleted
 * @returns 
 */
export const deleteMessageHLS = async (videoPath) => {
    console.log(`deleteMessageHLS ${videoPath} `)
    const url = `${process.env.REACT_APP_CORE_SERVICE}media/video/delete/allMedia`
    return fetch(url, getCoreServiceFetchOptions('POST', JSON.stringify({ videoPath })))
        .then(handleErrors)
        .then(() => {
            return true
        })
}

/**
 * Requires Api key.
 * 
 * @param {*} roomParams 
 * @returns 
 */
export const getRoom = async (roomParams) => {
    console.log(`getRoom`, roomParams)
    const url = `${process.env.REACT_APP_CORE_SERVICE}vortex/getRoom`
    return fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'x-api-key': process.env.REACT_APP_API_KEY
        },
        body: JSON.stringify(roomParams),
    })
        .then(handleErrors)
        .then((res) => res.json())
        .then((room) => {
            console.log('got room', room)
            return room
        })
}

/**
 * Requires Api key.
 * 
 * @param {*} roomId 
 * @returns 
 */
export const getRoomById = async (roomId) => {
    console.log(`getRoomById`, roomId)
    const url = `${process.env.REACT_APP_CORE_SERVICE}vortex/getRoomById/${roomId}`
    return fetch(url, {
        method: 'GET',
        headers: {
            'x-api-key': process.env.REACT_APP_API_KEY
        }
    })
        .then(handleErrors)
        .then((res) => res.json())
        .then((room) => {
            console.log('got room', room)
            return room
        })
}

export const incrementRoomViews = async (roomId) => {
    console.log(`incrementRoomViews ${roomId}`)
    const url = `${process.env.REACT_APP_CORE_SERVICE}vortex/incrementRoomViews/${roomId}`
    return fetch(url, {
        method: 'GET',
        headers: {
            'x-api-key': process.env.REACT_APP_API_KEY
        }
    })
        .then(handleErrors)
        .then((res) => res.json())
        .then((room) => {
            return room
        })
}

/**
 * Update the Core server Room
 * @param {*} room
 * @returns The updated room
 */
export const updateRoom = async (room) => {
    return fetch(`${process.env.REACT_APP_CORE_SERVICE}vortex/updateRoom`,
        getCoreServiceFetchOptions('POST', JSON.stringify(room)))
        .then(handleErrors)
        .then((res) => res.json())
        .then((updatedRoom) => {
            console.log('Updated room', updatedRoom)
            return updatedRoom
        })
}

